import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import i18n from '../../i18n';
import { RootState } from '../reducers/rootReducer';
import { printLocationReport } from '../actions/activePickTour.actions';
import { createToast } from '../actions/toasts.actions';
import { setLoading } from '../actions/loading.actions';

import {
  BFF_PICK_TOURS,
  BFF_V1,
  PRINT_LOCATION_REPORT,
  SAGA_PRINT_LOCATION_REPORT,
  PICKING_APIGEE_BASE_PATH,
} from '../../constants';

import { ConfigAuthValues } from '../../types';

import { callAPI } from '../../utils';

import { catchApiErrors, handleApiErrors } from './utils';
import { PrintLocationReportResponse } from './types';

const callPrintLocationReport = (pickTourId: string, configAuthValues: ConfigAuthValues) =>
  callAPI({
    method: 'POST',
    url: `${configAuthValues.APIGEE_BASE_URL}${PICKING_APIGEE_BASE_PATH}${BFF_V1}${BFF_PICK_TOURS}/${pickTourId}${PRINT_LOCATION_REPORT}`,
    data: {},
  });

export function* runPrintLocationReportSaga(action: ReturnType<typeof printLocationReport>) {
  const configAuthValues = yield select((state: RootState) => state.config.authValues);

  yield put(setLoading({ sagaName: SAGA_PRINT_LOCATION_REPORT, isLoading: true }));

  try {
    const { data }: { data: PrintLocationReportResponse } = yield call(
      callPrintLocationReport,
      action.payload.pickTourId,
      configAuthValues
    );
    const { errors } = data;
    if (errors.length === 0) {
      yield put(createToast({ type: 'success', message: i18n.t('PRINT_REQUEST_SUCCESS') }));
    } else {
      yield handleApiErrors(errors);
    }
  } catch (error) {
    try {
      const { pickTourId } = action.payload;
      const url = `${PICKING_APIGEE_BASE_PATH}${BFF_V1}${BFF_PICK_TOURS}/${pickTourId}${PRINT_LOCATION_REPORT}`;
      const method = 'POST';
      const data = {};
      const config = configAuthValues;
      yield catchApiErrors(error, { url, method, data, config, saga: SAGA_PRINT_LOCATION_REPORT });
    } catch (_error) {
      yield catchApiErrors(error);
    }
  }

  yield put(setLoading({ sagaName: SAGA_PRINT_LOCATION_REPORT, isLoading: false }));
}

export default function* watchPrintLocationReport() {
  yield takeEvery(getType(printLocationReport), runPrintLocationReportSaga);
}
